<template>
  <div id="coups-de-coeur-home">
    <div :class="isPhone ? '' : 'pb-3'">
      <div :class="isPhone ? '' : 'row row-hubs'">
        <div class="col-12 d-flex justify-content-center align-items-center">
          <div class="lodging-header text-center">
            <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class="mb-0 text-center">Nos</p>
            <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0 text-center">Coups de Cœur</p>
            <p :class="isPhone ? 'merriweather-light-18 mb-1' : 'merriweather-light-24 mb-1'">Notre sélection confidentielle pour profiter de <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">privilèges exclusifs</span></p>
          </div>
        </div>
        <div class="tabs-container pt-4">
          <div class="destination-tabs">
            <button
              v-for="destination in ['France', 'Océan Indien', 'Caraïbes', 'Afrique']"
              :key="destination"
              @click="selectDestination(destination)"
              :class="['destination-tab', { active: selectedDestination === destination }]"
              class="raleway-bold-p15"
            >
              {{ destination }}
            </button>
          </div>
        </div>
        <div class="card-container">
          <div class="container-fluid py-2 position-relative">
          <div class="d-flex flex-row flex-nowrap" id="scroller" style="overflow: scroll; overflow-y: hidden">
            <div class="card card-body border-0" v-if="filteredLodgings"  v-for="lodging in filteredLodgings" :key="lodging.id" style="min-height: auto; min-width: auto; margin-right:25px; max-width: 334px;">
            <CardProductHome data-aos="fade-up" data-aos-duration="900" :lodging="lodging" :user="isUserConnected()" @connection="$emit('connection')"></CardProductHome>
            </div>
          </div>
          <div class="flex-shrink-0 previous-slide-button circle-icon" v-if="filteredLodgings && !isPhone" @click="scroll_left">
            <img src="../../images/arrow-left.svg" alt="Previous" />
          </div>
          <div class="flex-shrink-0 next-slide-button circle-icon" v-if="filteredLodgings && !isPhone" @click="scroll_right">
            <img src="../../images/arrow-right.svg" alt="Next" />
          </div>
        </div>
        </div>
      </div>
    </div>
    <!-- <div class="row d-flex align-items-center justify-content-center lodging-redirect-btn">
      <a class="hortense-btn-primary raleway-bold-p" :href="'/reservation-hotel'" target="_blank">Découvrir notre sélection</a>
    </div> -->
  </div>
</template>

<script>
import CardProduct from 'components/cards/CardProduct.vue';
import CardProductHome from "components/cards/CardProductHome.vue";
import AOS from "aos";

export default {
  name: 'CoupsDeCoeurDestinations',
  props: {
    user: Object
  },
  components: {CardProductHome, CardProduct },
  data() {
    return {
      selectedDestination: 'France',
      fetchedLodgings: [],
      isPhone: window.innerWidth <= 768
    };
  },
  methods: {
    selectDestination(destination) {
      this.selectedDestination = destination;
      this.fetchLodgingsByDestination(destination);
    },
    async fetchLodgingsByDestination(destination) {
      try {
        const response = await fetch(`/lodgings/coups_de_coeur_by_destination?country=${encodeURIComponent(destination)}`);
        if (!response.ok) {
          console.error('Failed to fetch lodgings:', response.statusText);
          this.fetchedLodgings = [];
          return;
        }
        this.fetchedLodgings = await response.json();
      } catch (error) {
        console.error('Error fetching lodgings:', error);
        this.fetchedLodgings = [];
      }
    },
    autoScroll() {
      const scroller = document.getElementById('scroller');
      const step = 0.3; // Adjust step for speed
      let maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

      const frame = () => {
        if (scroller.scrollLeft >= maxScrollLeft) {
          scroller.scrollLeft = 0; // Reset scroll to start when it reaches the end
          maxScrollLeft = scroller.scrollWidth - scroller.clientWidth; // Recalculate in case of dynamic content
        } else {
          scroller.scrollLeft += step;
        }
        requestAnimationFrame(frame);
      }
      frame();
    },
    goToGroup(url){
      //Turbolinks.visit(url);
      window.open(url, '_blank');
    },
    isUserConnected() {
      return this.user ? this.user : {};
    },
    scroll_left() {
      let content = document.querySelector("#scroller");
      content.scrollLeft -= 220;
    },
    scroll_right() {
      let content = document.querySelector("#scroller");
      content.scrollLeft += 220;
    }
  },
  computed: {
    filteredLodgings() {
      if (this.fetchedLodgings && this.fetchedLodgings.length > 0) {
        return this.fetchedLodgings;
      }
      if (!this.lodgings) return [];
      return this.lodgings.filter(lodging => lodging?.country?.name === this.selectedDestination);
    }
  },
  mounted() {
    AOS.init();
    this.autoScroll();
    this.fetchLodgingsByDestination(this.selectedDestination);
  }
};
</script>
<style scoped>

  #coups-de-coeur-home {
    padding-top: 150px;

    .hub-img, .hub-img-zoom {
      width: 334px !important;
      height: 277px !important;
    }
    .circle-icon {
      width: 35px;
      height: 35px;
      border: 1px solid black;
      background: #000;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      flex-shrink: 0;

      img {
        width: 20px;
      }
    }
    .previous-slide-button {
      position: absolute;
      top: 30%;
      transform: translateY(-50%);
      left: 0;
      color: #F7F7F7;
      background-color: black;

      i {
        color: black;
      }
    }

    .next-slide-button {
      position: absolute;
      top: 30%;
      transform: translateY(-50%);
      right: 0;
      color: #F7F7F7;
      background-color: black;

      i {
        color: white;
      }
    }

    .container-fluid {
      padding-left: 50px;
      padding-right: 50px;
    }
  }
  .experience-card-leave {
    background-image: linear-gradient(270.13deg, rgba(255, 255, 255, 0) 12.44%, rgba(255, 255, 255, 0.8) 58.96%),
      url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-club-green-note.jpg');
    width: 100%;
    height: 188px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 24px 50px 24px 75px;

    .leave-left, .leave-right, .img-leaf-left, .img-leaf-right {
      width: 100px;
      height: 100px;
    }

    .text-section {
      line-height: 100%;

      .description {
        line-height: 24px;
      }
    }

    @media (max-width: 1190px) {
      .text-section {
        line-height: 100%;
        padding-top:10px;

        .description {
          line-height: 18px;
        }
      }
    }
  }

  .underline_text {
    text-decoration: underline;;
  }

  .tabs-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.destination-tabs {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 100%;

  @media screen and (max-width: 768px) {
    gap: 15px;
  }
}

.destination-tab {
  padding: 12px 0;
  border: none;
  background-color: transparent;
  color: #524F4FDD;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 2px solid transparent;
  text-transform: uppercase;
  letter-spacing: 1px;

  &:hover {
    color: #000000;
  }

  &.active {
    color: #000000;
    border-bottom: 2px solid #3B6152;
  }
}

@media screen and (max-width: 768px) {
  .card-container {
    padding-left: unset !important;
    padding-right: unset !important;
  }

  .container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
  
</style>